import { trackLink } from '../utils.js';

onDomReady(function() {
   $$('.js-product-ad').each(function(el) {
      trackLink(el, `News - ${App.postTitle} - ${App.postid}`, 'click', el.get('data-ga-label'));
   });
});
